import { ArrowRightOutlined } from '@ant-design/icons'
import { Empty, Skeleton, Timeline } from 'antd'
import { ILogs } from 'egi/repositories/ConfigurationsRepository'
import React from 'react'
import { timeAsDayjs } from 'utils/time'

export const OperationalHistoryLastModified = ({ updatedAt, modifiedName }: { updatedAt: string, modifiedName: string }) => {
  return <span>
    Alterado <b>{timeAsDayjs(updatedAt).format('DD/MM/YYYY [às] HH:mm')}</b>&nbsp;
  por&nbsp;<b>{modifiedName}</b>
  </span>
}

export const OperationalShowHistory = ({ history, historyLoading }: { history: ILogs[] | undefined, historyLoading: boolean }) => {
  if (historyLoading) {
    return <Timeline>
      <Timeline.Item >
        <Skeleton />
      </Timeline.Item>
    </Timeline>
  }
  const operationalLimitLabels: Record<string, string> = {
    creditoAnalistaJunior: 'Analista Júnior',
    creditoAnalistaPleno: 'Analista Pleno',
    creditoAnalistaSenior: 'Analista Sênior',
    creditoEspecialista: 'Especialista de Crédito',
    creditoCoordenador: 'Coordenador de Crédito',
    creditoGerente: 'Gerente',
    creditoSuperintendente: 'Superintendente',
    creditoDiretor: 'Diretor'
  }
  if (history?.length) {
    return (
      <Timeline>
        {history?.map(item => {
          return (
            <Timeline.Item key={item._id}>
              <div className="mb-2">
                <OperationalHistoryLastModified
                  updatedAt={item.createdAt}
                  modifiedName={item.modifiedBy.name}
                />
              </div>
              {Object.entries(item.last).map(([field, lastField]) => {
                const newField = item.new[field]
                if (newField === undefined) {
                  return null
                }
                const label = operationalLimitLabels[field] || field
                const isLastObj = typeof lastField === 'object' && lastField !== null && !Array.isArray(lastField)
                const isNewObj = typeof newField === 'object' && newField !== null && !Array.isArray(newField)

                if (isLastObj && isNewObj) {
                  const lastObj = lastField as { min?: number; max?: number }
                  const newObj = newField as { min?: number; max?: number }
                  const minExists = 'min' in lastObj && 'min' in newObj
                  const maxExists = 'max' in lastObj && 'max' in newObj
                  const minChanged = minExists && lastObj.min !== newObj.min
                  const maxChanged = maxExists && lastObj.max !== newObj.max
                  return (
                    <div key={field}>
                      {minExists && minChanged && (
                        <div>
                          Mudança em <b>{label}</b> min <b>{lastObj.min ?? '-'}</b>
                          <ArrowRightOutlined style={{ margin: '0 4px' }}/>
                          <b>{newObj.min ?? '-'}</b>
                        </div>
                      )}
                      {maxExists && maxChanged && (
                        <div>
                          Mudança em <b>{label}</b> max <b>{lastObj.max ?? '-'}</b>
                          <ArrowRightOutlined style={{ margin: '0 4px' }}/>
                          <b>{newObj.max ?? '-'}</b>
                        </div>
                      )}
                    </div>
                  )
                }

                if (typeof lastField === 'number' && typeof newField === 'number') {
                  if (lastField === newField) {
                    return null
                  }
                  return (
                    <div key={field}>
                      <div>
                        Mudança em <b>{label}</b> <b>{lastField}</b>
                        <ArrowRightOutlined style={{ margin: '0 4px' }}/>
                        <b>{newField}</b>
                      </div>
                    </div>
                  )
                }

                return null
              })}
            </Timeline.Item>
          )
        })}
      </Timeline>
    )
  }

  return <div className="text-center">
    <Empty
      description="Não foi possível encontrar nenhum histórico de revisão para esse passo"
    />
  </div>
}
